/* Maison Sel Doré — storefront behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  const formatMoney = (cents, format = (window.theme && theme.moneyFormat) || '${{amount}}') => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thousands = ',', dec = '.') => {
      const fixed = n.toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + dec + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2);
        case 'amount_no_decimals': return fmt(value, 0);
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2);
      }
    });
  };

  /* ---------- layers ---------- */
  // Drawers rendered inside the sticky header would be trapped in its stacking context
  // (below the scrim and announcement bar). Lift them to <body> so they sit on top.
  const liftLayers = () => {
    $$('.header-section [data-drawer], .header-section [data-search-panel]').forEach((el) => {
      $$(`body > #${el.id}`).forEach((old) => old.remove());
      document.body.appendChild(el);
    });
  };
  liftLayers();
  document.addEventListener('shopify:section:load', liftLayers);

  /* ---------- body lock + scrim ---------- */
  const scrim = $('[data-scrim]');
  let openLayer = null;
  let lastFocus = null;

  const showScrim = () => {
    if (!scrim) return;
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add('is-visible'));
  };
  const hideScrim = () => {
    if (!scrim) return;
    scrim.classList.remove('is-visible');
    setTimeout(() => { if (!openLayer) scrim.hidden = true; }, 400);
  };

  const openDrawer = (el, trigger) => {
    if (!el) return;
    if (openLayer && openLayer !== el) closeLayer();
    lastFocus = trigger || document.activeElement;
    el.classList.add('is-open');
    openLayer = el;
    document.body.classList.add('is-locked');
    showScrim();
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = el.querySelector('button, a, input, select, textarea');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 60);
  };

  const closeLayer = () => {
    if (!openLayer) return;
    const el = openLayer;
    el.classList.remove('is-open');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openLayer = null;
    document.body.classList.remove('is-locked');
    hideScrim();
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.openDrawer), opener);
      return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target.closest('[data-close-search]') || e.target === scrim) {
      closeLayer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeLayer();
      closeMegas();
    }
    if (e.key === 'Tab' && openLayer) {
      const items = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea', openLayer)
        .filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header ---------- */
  const header = $('[data-header]');
  const announcement = $('[data-announcement]');
  const overlay = document.body.classList.contains('has-overlay-header');
  let megaOpen = false;
  let headerHover = false;

  const syncHeader = () => {
    if (!header) return;
    const annH = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty('--announce-h', annH + 'px');
    if (overlay) {
      document.documentElement.style.setProperty('--announce-offset', Math.max(0, annH - window.scrollY) + 'px');
      const solid = window.scrollY > 24 || megaOpen || headerHover || openLayer;
      header.classList.toggle('is-solid', Boolean(solid));
    }
  };
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { syncHeader(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', syncHeader);
  syncHeader();

  if (header && overlay) {
    header.addEventListener('mouseenter', () => { headerHover = true; syncHeader(); });
    header.addEventListener('mouseleave', () => { headerHover = false; syncHeader(); });
  }

  /* mega menu */
  const navItems = $$('[data-nav-item]');
  let megaTimer = null;
  const closeMegas = () => {
    navItems.forEach((i) => {
      i.classList.remove('is-open');
      const a = i.querySelector('.nav__link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
    megaOpen = false;
    syncHeader();
  };
  const openMega = (item) => {
    navItems.forEach((i) => { if (i !== item) i.classList.remove('is-open'); });
    item.classList.add('is-open');
    const a = item.querySelector('.nav__link');
    if (a) a.setAttribute('aria-expanded', 'true');
    megaOpen = true;
    syncHeader();
  };
  navItems.forEach((item) => {
    item.addEventListener('mouseenter', () => { clearTimeout(megaTimer); megaTimer = setTimeout(() => openMega(item), 90); });
    item.addEventListener('mouseleave', () => { clearTimeout(megaTimer); megaTimer = setTimeout(closeMegas, 160); });
    item.addEventListener('focusin', () => openMega(item));
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) closeMegas(); });
    const link = item.querySelector('.nav__link');
    if (link) {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          openMega(item);
        }
      });
    }
  });

  /* announcement rotation */
  if (announcement) {
    const items = $$('.announcement__item', announcement);
    if (items.length > 1 && !reduceMotion) {
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 5000);
    }
  }

  /* search */
  const searchPanel = $('[data-search-panel]');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]') && searchPanel) {
      e.preventDefault();
      openDrawer(searchPanel, e.target.closest('[data-open-search]'));
      const input = $('input[type=search]', searchPanel);
      if (input) setTimeout(() => input.focus(), 80);
    }
  });

  /* ---------- reveal on scroll ---------- */
  const revealTargets = $$('[data-reveal], [data-hero]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.forEach((el) => io.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- membership (le cercle) ---------- */
  const member = (window.theme && theme.member) || {};
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } },
  };

  // Saving the member code to the cart: Shopify keeps a discount applied from /discount/CODE
  // and checkout honours it when the buyer's email belongs to the members segment.
  const applyMemberCode = () => {
    if (!member.code) return;
    try { if (sessionStorage.getItem('msd-member-code') === member.code) return; } catch (e) { /* ignore */ }
    fetch(`${theme.routes.root.replace(/\/$/, '')}/discount/${encodeURIComponent(member.code)}`, { credentials: 'same-origin' })
      .then(() => { try { sessionStorage.setItem('msd-member-code', member.code); } catch (e) { /* ignore */ } })
      .catch(() => {});
  };

  const memberModal = $('[data-member-modal]');
  const openMember = () => {
    if (!memberModal) return;
    lastFocus = document.activeElement;
    memberModal.hidden = false;
    requestAnimationFrame(() => memberModal.classList.add('is-open'));
    document.body.classList.add('is-locked');
    const field = $('input[type=email], .btn', memberModal);
    if (field) setTimeout(() => field.focus({ preventScroll: true }), 120);
  };
  const closeMember = () => {
    if (!memberModal || memberModal.hidden) return;
    memberModal.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(() => { memberModal.hidden = true; }, 350);
    if (store.get('msd-cercle') !== 'joined') store.set('msd-cercle', 'dismissed');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  const justJoined = /[?&]customer_posted=true/.test(window.location.search)
    && ($('[data-member-success]') || $('.newsletter .form-message--success'));

  if (justJoined) {
    store.set('msd-cercle', 'joined');
    applyMemberCode();
    if (memberModal && window.location.hash === '#MemberPopupForm') openMember();
  } else if (member.isMember) {
    store.set('msd-cercle', 'joined');
    applyMemberCode();
  } else if (memberModal && !store.get('msd-cercle') && !document.body.classList.contains('no-member-popup')) {
    setTimeout(() => { if (!openLayer) openMember(); }, (Number(memberModal.dataset.delay) || 7) * 1000);
  }

  if (memberModal) {
    memberModal.addEventListener('click', (e) => {
      if (e.target === memberModal || e.target.closest('[data-member-close]')) closeMember();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMember(); });
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-member]');
    if (trigger && memberModal && !member.isMember) {
      e.preventDefault();
      closeLayer();
      setTimeout(openMember, 200);
    }
  });

  /* ---------- collection sort ---------- */
  const sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- cart ---------- */
  const cartDrawer = () => $('[data-cart-drawer]');

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.dataset.count = count;
      el.textContent = count > 0 ? count : '';
    });
    $$('[data-cart-toggle]').forEach((a) => a.setAttribute('aria-label', `cart, ${count} items`));
  };

  const refreshDrawer = async () => {
    const res = await fetch(`${theme.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', html);
    const current = cartDrawer();
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    loadUpsell();
  };

  const getCart = () => fetch(`${theme.routes.cart}.js`).then((r) => r.json());

  const openCart = async (trigger) => {
    const drawer = cartDrawer();
    if (!drawer) { window.location.href = theme.routes.cart; return; }
    openDrawer(drawer, trigger);
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && cartDrawer() && theme.cartDrawer) {
      e.preventDefault();
      openCart(toggle);
    }
  });

  const changeLine = async (line, quantity, inDrawer) => {
    const drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-busy');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      const cart = await res.json();
      if ($('[data-cart-page]') && !inDrawer) { window.location.reload(); return; }
      updateCount(cart.item_count);
      await refreshDrawer();
    } finally {
      const d = cartDrawer();
      if (d) d.classList.remove('is-busy');
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const line = btn.closest('[data-line]');
    if (!line) return;
    e.preventDefault();
    changeLine(line.dataset.line, btn.dataset.qtyChange, Boolean(btn.closest('[data-cart-drawer]')));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const line = input.closest('[data-line]');
    changeLine(line.dataset.line, Math.max(0, parseInt(input.value, 10) || 0), Boolean(input.closest('[data-cart-drawer]')));
  });

  /* ---------- product ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const jsonEl = $('[data-product-json]');
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('[data-product-form]', productEl);
    const idInput = form ? $('[data-variant-id]', form) : null;
    const addBtn = form ? $('[data-add-button]', form) : null;
    const addLabel = addBtn ? $('[data-add-label]', addBtn) : null;
    const errorEl = form ? $('[data-form-error]', form) : null;
    const stage = $('[data-stage]', productEl);
    const stageNote = $('[data-stage-note]', productEl);
    const priceValue = $('[data-price-value]', productEl);
    const buybar = $('[data-buybar]');
    const buybarPrice = buybar ? $('[data-buybar-price]', buybar) : null;
    const frames = () => $$('.framed', document).filter((f) => f.closest('[data-stage], .p-hero__thumb'));

    const selectedOptions = () => $$('fieldset[data-option-index]', form).map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const update = () => {
      if (!product) return;
      const opts = selectedOptions();
      const variant = findVariant(opts);

      $$('fieldset[data-option-index]', form).forEach((fs) => {
        const checked = $('input:checked', fs);
        const label = $('[data-option-value]', fs);
        if (checked && label) label.textContent = checked.value.replace(/\.00(?!\d)/, '');
        if (checked && checked.dataset.frameKey) frames().forEach((f) => { f.dataset.frame = checked.dataset.frameKey; });
        if (checked && checked.dataset.mountKey) frames().forEach((f) => { f.dataset.mount = checked.dataset.mountKey; });
        if (checked && checked.dataset.sizeIndex !== undefined && stage) {
          stage.dataset.sizeIndex = checked.dataset.sizeIndex;
          if (stageNote) stageNote.textContent = checked.value;
        }
      });

      if (errorEl) errorEl.hidden = true;
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'unavailable';
        return;
      }
      idInput.value = variant.id;
      // whole prices read cleaner without cents, matching money_without_trailing_zeros in Liquid
      const price = formatMoney(variant.price).replace(/[.,]00(?!\d)/, '');
      if (priceValue) priceValue.textContent = price;
      if (buybarPrice) buybarPrice.textContent = price;
      // member prices round up to the next whole dollar, the same rule the size table uses
      const memberCents = Math.ceil((variant.price * (100 - (theme.member.discount || 0))) / 10000) * 100;
      const whole = (cents) => formatMoney(cents).replace(/[.,]00(?!\d)/, '');
      $$('[data-price-regular]', productEl).forEach((el) => { el.textContent = price; });
      $$('[data-price-member]', productEl).forEach((el) => { el.textContent = whole(memberCents); });
      $$('[data-member-save-amount]', productEl).forEach((el) => { el.textContent = whole(variant.price - memberCents); });
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? `add to cart · ${price}` : 'sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    if (form) form.addEventListener('change', (e) => { if (e.target.matches('input[type=radio]')) update(); });

    if (form && theme.cartDrawer) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        try {
          const res = await fetch(`${theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await res.json();
          if (data.status) {
            if (errorEl) { errorEl.textContent = data.description || data.message; errorEl.hidden = false; }
            return;
          }
          const cart = await getCart();
          updateCount(cart.item_count);
          await refreshDrawer();
          openCart(addBtn);
        } catch (err) {
          form.submit();
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });
    }

    /* description clamp */
    const desc = $('[data-desc]', productEl);
    const descToggle = $('[data-desc-toggle]', productEl);
    if (desc && descToggle) {
      requestAnimationFrame(() => {
        if (desc.scrollHeight > desc.clientHeight + 4) descToggle.hidden = false;
        else desc.classList.remove('is-clamped');
      });
      descToggle.addEventListener('click', () => {
        const clamped = desc.classList.toggle('is-clamped');
        descToggle.textContent = clamped ? 'read more' : 'read less';
      });
    }

    /* mobile buy bar */
    if (buybar && addBtn && 'IntersectionObserver' in window) {
      const bio = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        buybar.classList.toggle('is-visible', show);
        buybar.setAttribute('aria-hidden', show ? 'false' : 'true');
        const btn = $('[data-buybar-add]', buybar);
        if (btn) btn.tabIndex = show ? 0 : -1;
      });
      bio.observe(addBtn);
      $('[data-buybar-add]', buybar).addEventListener('click', () => {
        addBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        setTimeout(() => addBtn.focus({ preventScroll: true }), 400);
      });
    }

    /* recommendations */
    const rec = $('[data-recommendations]');
    if (rec && rec.dataset.url) {
      fetch(rec.dataset.url).then((r) => r.text()).then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = $('[data-recommendations]', html);
        if (fresh && fresh.innerHTML.trim()) rec.innerHTML = fresh.innerHTML;
      }).catch(() => {});
    }
  }

  /* ---------- detail loupe ---------- */
  // "zoom in" turns on a square magnifier that follows the cursor, or one finger on touch screens, over the
  // print. It only ever shows a window of the high-resolution image, never the whole print up close.
  const loupeStage = $('[data-loupe]');
  const loupeArt = loupeStage && $('.framed__art', loupeStage);
  const loupePic = loupeArt && $('img', loupeArt);
  if (loupePic) {
    const glass = document.createElement('div');
    glass.className = 'loupe';
    glass.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glass);
    const narrow = window.matchMedia('(max-width: 749px)');
    const fullWidth = +loupeStage.dataset.loupeWidth || Infinity;
    const toggle = $('[data-loupe-toggle]', loupeStage);
    let hi = '', hiWidth = 0, pending = 0, last = null, touchId = null, enabled = false;

    // inside the glass the print is about twice its size on screen, 400 to 1400 px wide
    const metrics = () => {
      const r = loupePic.getBoundingClientRect();
      const zoomed = Math.min(1400, Math.max(narrow.matches ? 400 : 640, r.width * 2.2));
      return { r, d: narrow.matches ? 200 : 300, m: zoomed / Math.max(1, r.width) };
    };
    // a sharper copy sized to the magnification and screen density, fetched once and upgraded only when needed
    const sharpen = (r, m) => {
      const want = Math.min(fullWidth, Math.ceil((r.width * m * (window.devicePixelRatio || 1)) / 250) * 250);
      if (want <= hiWidth || want <= pending) return;
      pending = want;
      const url = new URL(loupeStage.dataset.loupe, window.location.href);
      url.searchParams.set('width', want);
      const pre = new Image();
      pre.onload = () => { if (want > hiWidth) { hi = url.href; hiWidth = want; paint(); } };
      pre.src = url.href;
    };
    const paint = () => {
      if (!last) return;
      const { r, d, m } = metrics();
      const nw = loupePic.naturalWidth || r.width, nh = loupePic.naturalHeight || r.height;
      // the print fills its window with object-fit: cover, so map the pointer through that crop
      const sc = Math.max(r.width / nw, r.height / nh);
      const px = Math.min(r.width, Math.max(0, last.x - r.left)) - (r.width - nw * sc) / 2;
      const py = Math.min(r.height, Math.max(0, last.y - r.top)) - (r.height - nh * sc) / 2;
      const lo = loupePic.currentSrc || loupePic.src;
      glass.style.setProperty('--loupe-d', d + 'px');
      glass.style.backgroundImage = hi ? `url("${hi}"), url("${lo}")` : `url("${lo}")`;
      glass.style.backgroundSize = `${nw * sc * m}px ${nh * sc * m}px`;
      glass.style.backgroundPosition = `${d / 2 - px * m}px ${d / 2 - py * m}px`;
      // under a finger the glass floats above the touch point so the finger never covers it
      const gx = Math.min(window.innerWidth - d - 8, Math.max(8, last.x - d / 2));
      const gy = Math.max(8, last.touch ? last.y - d - 36 : last.y - d / 2);
      glass.style.translate = `${gx}px ${gy}px`;
      sharpen(r, m);
    };
    const show = (e, touch) => {
      last = { x: e.clientX, y: e.clientY, touch };
      paint();
      glass.classList.add('is-on');
      loupeStage.classList.add('is-magnifying');
    };
    const hide = () => {
      last = null;
      glass.classList.remove('is-on');
      loupeStage.classList.remove('is-magnifying');
    };

    const setEnabled = (on) => {
      enabled = on;
      loupeStage.classList.toggle('is-loupe-on', on);
      if (toggle) toggle.setAttribute('aria-pressed', String(on));
      if (on) { const { r, m } = metrics(); sharpen(r, m); } else { touchId = null; hide(); }
    };
    if (toggle) toggle.addEventListener('click', () => setEnabled(!enabled));

    loupeArt.addEventListener('pointerenter', (e) => { if (enabled && e.pointerType === 'mouse') show(e, false); });
    loupeArt.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') hide(); });
    loupeArt.addEventListener('pointerdown', (e) => {
      if (!enabled || e.pointerType === 'mouse' || touchId !== null) return;
      touchId = e.pointerId;
      try { loupeArt.setPointerCapture(e.pointerId); } catch (err) { /* the finger is still tracked while it stays on the print */ }
      show(e, true);
    });
    loupeArt.addEventListener('pointermove', (e) => {
      if (!enabled) return;
      if (e.pointerType === 'mouse') show(e, false);
      else if (e.pointerId === touchId) show(e, true);
    });
    const release = (e) => { if (e.pointerId === touchId) { touchId = null; hide(); } };
    loupeArt.addEventListener('pointerup', release);
    loupeArt.addEventListener('pointercancel', release);
    loupeArt.addEventListener('contextmenu', (e) => e.preventDefault());
    loupeArt.addEventListener('dragstart', (e) => e.preventDefault());
    window.addEventListener('scroll', () => { if (touchId === null) hide(); }, { passive: true });
  }
  /* ---------- member price explainer ---------- */
  document.addEventListener('click', (e) => {
    const help = e.target.closest('[data-price-help]');
    $$('[data-price-pop]').forEach((pop) => {
      const owner = $(`[aria-controls="${pop.id}"]`);
      const open = help && help === owner ? pop.hidden : false;
      if (!help && pop.contains(e.target)) return;
      pop.hidden = !open;
      if (owner) owner.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-price-pop]').forEach((pop) => { pop.hidden = true; });
    $$('[data-price-help]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  });

  /* ---------- wishlist ---------- */
  // Saved per browser. A signed-in customer gets their own list, and anything saved before signing in joins it.
  const GUEST_KEY = 'msd-wishlist-guest';
  const WISH_KEY = theme.customerId ? `msd-wishlist-${theme.customerId}` : GUEST_KEY;
  const readList = (key = WISH_KEY) => { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } };
  const writeList = (list) => { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ } };
  if (theme.customerId) {
    const guest = readList(GUEST_KEY);
    if (guest.length) {
      writeList([...new Set([...readList(), ...guest])]);
      try { localStorage.removeItem(GUEST_KEY); } catch (e) { /* ignore */ }
    }
  }
  const syncWish = () => {
    const list = readList();
    $$('[data-wish]').forEach((b) => {
      const on = list.includes(b.dataset.wish);
      b.setAttribute('aria-pressed', String(on));
      b.classList.toggle('is-on', on);
    });
    $$('[data-wish-count]').forEach((el) => { el.dataset.count = list.length; el.textContent = list.length || ''; });
  };
  const toast = (html) => {
    let t = $('[data-toast]');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); t.dataset.toast = ''; document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('is-on'), 4200);
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.wish;
    let list = readList();
    const adding = !list.includes(handle);
    list = adding ? [...list, handle] : list.filter((h) => h !== handle);
    writeList(list);
    syncWish();
    // on your own wishlist page, unsaving a print takes it off the page
    const ownList = btn.closest('[data-wishlist-grid]') && !new URLSearchParams(window.location.search).get('items');
    if (!adding && ownList) {
      const card = btn.closest('.card');
      if (card) card.remove();
      if (!list.length) {
        const empty = $('[data-wishlist-empty]');
        const tools = $('[data-wishlist-tools]');
        if (empty) empty.hidden = false;
        if (tools) tools.hidden = true;
      }
    }
    if (adding) {
      toast(theme.customerId
        ? `saved to your <a href="${theme.wishlistUrl}">wishlist</a>`
        : `saved to your <a href="${theme.wishlistUrl}">wishlist</a>. <a href="${theme.loginUrl}">sign in</a> to keep it with your account.`);
    }
  }, true);
  syncWish();

  const wishPage = $('[data-wishlist-page]');
  if (wishPage) {
    const params = new URLSearchParams(window.location.search);
    const shared = (params.get('items') || '').split(',').map((h) => h.trim()).filter((h) => /^[a-z0-9-]+$/.test(h));
    const handles = shared.length ? shared : readList();
    const grid = $('[data-wishlist-grid]', wishPage);
    const empty = $('[data-wishlist-empty]', wishPage);
    const tools = $('[data-wishlist-tools]', wishPage);
    const sharedNote = $('[data-wishlist-shared]', wishPage);
    const guestNote = $('[data-wishlist-guest]', wishPage);
    if (guestNote) guestNote.hidden = Boolean(theme.customerId) || shared.length > 0;
    if (sharedNote) sharedNote.hidden = !shared.length;
    const render = async () => {
      const cards = await Promise.all(handles.map(async (h) => {
        try {
          const r = await fetch(`/products/${h}?view=card`);
          return r.ok ? await r.text() : '';
        } catch (e) { return ''; }
      }));
      const html = cards.filter(Boolean).join('');
      grid.innerHTML = html;
      empty.hidden = Boolean(html);
      if (tools) tools.hidden = !html;
      syncWish();
    };
    render();
    const shareBtn = $('[data-wishlist-share]', wishPage);
    if (shareBtn) shareBtn.addEventListener('click', async () => {
      const list = shared.length ? shared : readList();
      const url = `${window.location.origin}${theme.wishlistUrl}?items=${list.join(',')}`;
      const label = $('span', shareBtn);
      try {
        if (navigator.share) { await navigator.share({ title: document.title, url }); return; }
        await navigator.clipboard.writeText(url);
        if (label) { label.textContent = 'link copied'; setTimeout(() => { label.textContent = 'share'; }, 2400); }
      } catch (e) {
        window.prompt('copy this link', url);
      }
    });
    const saveAll = $('[data-wishlist-save-all]', wishPage);
    if (saveAll) saveAll.addEventListener('click', () => {
      writeList([...new Set([...readList(), ...shared])]);
      syncWish();
      toast(`saved to your <a href="${theme.wishlistUrl}">wishlist</a>`);
    });
  }

  /* ---------- cart upsell: prints that pair with what is in the cart ---------- */
  async function loadUpsell() {
    const box = $('[data-cart-upsell]');
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    const pid = box.dataset.productId;
    if (!pid) return;
    const exclude = new Set((box.dataset.exclude || '').split(','));
    try {
      const r = await fetch(`${theme.routes.root.replace(/\/$/, '')}/recommendations/products.json?product_id=${pid}&limit=8`);
      const data = await r.json();
      const picks = (data.products || []).filter((p) => p.available && !exclude.has(String(p.id)) && p.handle !== 'gift-card').slice(0, 3);
      if (!picks.length) return;
      const whole = (cents) => formatMoney(cents).replace(/[.,]00(?!\d)/, '');
      $('[data-cart-upsell-list]', box).innerHTML = picks.map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        let img = '';
        if (p.featured_image) {
          const u = new URL(p.featured_image.startsWith('//') ? `https:${p.featured_image}` : p.featured_image, window.location.origin);
          u.searchParams.set('width', '240');
          img = `<img src="${u.href}" alt="" loading="lazy" width="120" height="150">`;
        }
        return `<div class="upsell-row">
          <a class="upsell-row__media" href="${p.url}" tabindex="-1">${img}</a>
          <div class="upsell-row__text"><a href="${p.url}">${p.title}</a><span class="t-muted">from ${whole(p.price_min)}</span></div>
          <button class="upsell-row__add" type="button" data-upsell-add="${v.id}" aria-label="add ${p.title}, ${v.option1}, to cart">add ${(v.option1 || '').replace(' in', '').replace(' x ', ' × ')}</button>
        </div>`;
      }).join('');
      box.hidden = false;
    } catch (e) { /* recommendations are optional */ }
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    btn.disabled = true;
    try {
      await fetch(`${theme.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.upsellAdd), quantity: 1 }] }) });
      const cart = await getCart();
      updateCount(cart.item_count);
      await refreshDrawer();
    } finally { btn.disabled = false; }
  });
  loadUpsell();
})();
